import { render, staticRenderFns } from "./DRP.vue?vue&type=template&id=2a55f4b8&scoped=true&"
import script from "./DRP.vue?vue&type=script&lang=js&"
export * from "./DRP.vue?vue&type=script&lang=js&"
import style0 from "./DRP.vue?vue&type=style&index=0&id=2a55f4b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a55f4b8",
  null
  
)

export default component.exports